import React, { useContext, useCallback }          from "react";
import { StyleSheet, Text, View }                  from "react-native";
import StyledInput                                 from "../../components/StyledInput";
import palette                                     from "../../styles/palette";
import Modal                                       from "../Modal";
import Row                                         from "../../layouts/Row";
import Col                                         from "../../layouts/Col";
import PhoneInput                                  from "../../components/PhoneInput/index";
import { useHistory }                              from "react-router-dom";

import ContactContext, { ContactProvider }         from "../../contexts/ContactContext";
import CustomersContext                            from "../../contexts/CustomersContext";
import UserContext                                 from "../../contexts/UserContext";
import COUNTRIES                                   from "../../constants/countries";
import HorizontalRule                              from '../../components/HorizontalRule/index';

export default function CustomerEditModal({ initial, location, onUpdate }) {
  const value = {
    ...initial,
  };

  if (initial.phone_number && !value.phone) {
    value.phone = initial.phone_number;
  }

  return (
    <ContactProvider value={value}>
      <CustomerForm participantId={location?.state?.participant?.id} onUpdate={onUpdate} />
    </ContactProvider>
  );
}

const CustomerForm = ({ onUpdate = null, participantId = "" }) => {
  const history = useHistory();
  const {
    user: {
      account: { country },
    },
  } = useContext(UserContext);
  const { getCustomers } = useContext(CustomersContext);
  const { contact, error, updateContact, saving, saveContact } =
    useContext(ContactContext);

  const onChange = useCallback(
    (attribute) => (val) => updateContact({ [attribute]: val }),
    [updateContact]
  );

  const onSave = useCallback(async () => {
    const res = await saveContact(participantId);

    if (onUpdate && res.response && !res.error) {
      onUpdate(res.response);
    }

    if (!res.error) {
      getCustomers("recent");
      history.goBack();
    }
  }, [saveContact, getCustomers, history, participantId, onUpdate]);

  return (
    <Modal
      title="Edit customer"
      confirmButtonProps={{
        loading: saving,
        label: "Save changes",
        color: palette.success,
        onPress: onSave,
      }}
    >
      <View style={[styles.customer_create_modal_container]}>
        {error && (
          <View style={[styles.error_message_container]}>
            <Text style={[styles.error_message_text]}>{error}</Text>
          </View>
        )}
        <View style={{ flexGrow: 2 }}>
          <Field label="First Name" required>
            <StyledInput onChangeText={onChange("first_name")} defaultValue={contact?.first_name} />
          </Field>
          <Field label="Last Name">
            <StyledInput onChangeText={onChange("last_name")} defaultValue={contact?.last_name} />
          </Field>
          <Field label="Email Address">
            <StyledInput onChangeText={onChange("email")} defaultValue={contact?.email} />
          </Field>
          <HorizontalRule />
          <Field label="Phone Number*" required>
            <PhoneInput onChange={onChange("phone")} country={country} defaultValue={contact?.phone} />
          </Field>
          <Field label="Alternate Phone Number*">
            <PhoneInput onChange={onChange("alt_phone")} country={country} defaultValue={contact?.alt_phone} />
          </Field>
          <Text style={{ fontSize: 11, paddingTop: 16 }}>
            *Including a country code improves our ability to send texts and
            place calls to this contact.
          </Text>
          <Text style={{ fontSize: 11, paddingBottom: 8 }}>
            *US & Toll free numbers should include "+1" as country code.
          </Text>
          <Text style={{ fontSize: 11, paddingTop: 8 }}>
            Your Country Code: [ {COUNTRIES[country].map}{" "}
            {COUNTRIES[country].value} : +{COUNTRIES[country].phoneCode} ]
          </Text>
{/*           <HorizontalRule />

          <Field label="Street Address">
            <StyledInput onChangeText={onChange("address_1")} />
          </Field>
          <Field label="Street Address Line 2">
            <StyledInput onChangeText={onChange("address_2")} />
          </Field>
          <Row>
            <Col pr={5}>
              <Field label="City">
                <StyledInput onChangeText={onChange("city")} />
              </Field>
            </Col>
            <Col pl={5}>
              <Field label="State">
                <StyledInput onChangeText={onChange("state")} />
              </Field>
            </Col>
          </Row>
          <Field label="Zip Code">
            <StyledInput onChangeText={onChange("zip_code")} />
          </Field> */}
        </View>
      </View>
    </Modal>
  );
};


const Field = ({ children, label, required }) => {
  return (
    <View style={[styles.field]}>
      <View style={[styles.field_label]}>
        <Row>
          <Col>
            <Text style={[styles.field_label_text]}>{label}</Text>
          </Col>
          {required && (
            <Col right>
              <Text style={[styles.field_label_required]}>Required</Text>
            </Col>
          )}
        </Row>
      </View>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  customer_create_modal_container: {
    paddingVertical: 15,
    display: "flex",
    flex: 1,
    height: "100%",
    flexDirection: "column",
  },
  field: {
    marginBottom: 4,
  },
  field_label: {
    padding: 8,
  },
  field_label_required: {
    color: palette.grey,
    fontWeight: "600",
  },
  field_label_text: {
    fontSize: 14,
    fontWeight: "500",
    color: palette.dark,
    // fontFamily: "acumin-pro, san-serif",
  },
  modal_footer: {
    position: "absolute",
    bottom: 0,
    width: "100%",
  },
  error_message_container: {
    backgroundColor: "#f8d7da",
    padding: 12,
    borderRadius: 4,
    marginBottom: 8,
  },
  error_message_text: {
    color: palette.danger,
    textAlign: "center",
    fontFamily: "acumin-pro, san-serif",
    fontWeight: "600",
  },
});
